export interface SortEntry {
  key: string;
  direction: 'asc' | 'desc';
}

export function parseSortString(raw: string): SortEntry {
  const field = raw.replace(/:(?:asc|desc)$/, '');
  const direction = raw.endsWith(':desc') ? 'desc' : 'asc';
  return { key: field, direction };
}

export function sortEntryToString(entry: SortEntry): string {
  return `${entry.key}:${entry.direction}`;
}

export function sortsToStrings(sorts: SortEntry[]): string[] {
  return sorts.map(sortEntryToString);
}

export function addSort(
  sorts: SortEntry[],
  key: string,
  direction: 'asc' | 'desc' = 'asc'
): SortEntry[] {
  if (sorts.some((s) => s.key === key)) return sorts;
  return [...sorts, { key, direction }];
}

export function removeSort(sorts: SortEntry[], key: string): SortEntry[] {
  return sorts.filter((s) => s.key !== key);
}

export function moveSort(sorts: SortEntry[], fromIndex: number, toIndex: number): SortEntry[] {
  if (fromIndex === toIndex) return sorts;
  const next = [...sorts];
  const [moved] = next.splice(fromIndex, 1);
  if (moved) {
    next.splice(toIndex, 0, moved);
  }
  return next;
}

export function toggleSortDirection(sorts: SortEntry[], key: string): SortEntry[] {
  return sorts.map((s) =>
    s.key === key ? { ...s, direction: s.direction === 'asc' ? 'desc' : 'asc' } : s
  );
}

export function setSortDirection(
  sorts: SortEntry[],
  key: string,
  direction: 'asc' | 'desc'
): SortEntry[] {
  return sorts.map((s) => (s.key === key ? { ...s, direction } : s));
}

export function findSortIndex(sorts: SortEntry[], key: string): number {
  return sorts.findIndex((s) => s.key === key);
}

export function migrateLegacySortByDirection(
  sortBy: string | undefined,
  sortDirection: string | undefined
): SortEntry[] {
  if (!sortBy) return [];
  const direction = sortDirection === 'desc' ? 'desc' : 'asc';
  return [{ key: sortBy, direction }];
}
